import { ref } from 'vue'
import { API_ROUTES } from '@/const/apiRoutes'
import api from '@/utils/api'

export interface BatchChoice {
  id: string
  name: string
}

export function useBatchChoices() {
  const batchChoices = ref<BatchChoice[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchBatchChoices = async () => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get<BatchChoice[]>(API_ROUTES.GET_BATCH_CHOICES)
      batchChoices.value = response.data
      return response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch batch choices'
      console.error('Error fetching batch choices:', err)
      return []
    } finally {
      isLoading.value = false
    }
  }

  const getBatchName = (batchId: string): string => {
    const batch = batchChoices.value.find(b => b.id === batchId)
    return batch?.name || batchId
  }

  return {
    batchChoices,
    isLoading,
    error,
    fetchBatchChoices,
    getBatchName
  }
} 